import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Button,
  Collapse,
  DialogTitle,
  DialogContent,
  TextField,
  Typography,
  Divider,
  IconButton,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Menu, Apps } from '@material-ui/icons';

import CloseButton from 'components/CustomButtons/CloseButton';
import { useAppDispatch } from 'reducers';
import { switchUserByPinOrPass } from 'actions/Login';
import Loader from 'components/Loader';
import { addWarning } from 'actions/Error';
import { previousModalPage } from 'actions/modalPage';
import { modalPages } from 'constants/modalPage';

export default function SwitchUser() {
  const { t } = useTranslation('switchUser');
  const dispatch = useAppDispatch();
  const [view, setView] = useState<'pin' | 'pass'>('pin');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');
  const [switching, setSwitching] = useState(false);

  const close = () => {
    if (!switching) {
      dispatch(previousModalPage({ component: modalPages.SwitchUser }));
    }
  };
  async function switchUser() {
    if (switching) {
      return;
    }

    setSwitching(true);
    try {
      if (view === 'pin') {
        await dispatch(switchUserByPinOrPass({ pin }));
      } else {
        await dispatch(switchUserByPinOrPass({ username, password }));
      }
      close();
    } catch (e) {
      dispatch(addWarning(t('alerts.failed', { message: e.message })));
    } finally {
      setSwitching(false);
    }
  }
  const enabled = view === 'pin' ? !!pin : !!username && !!password;

  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, [view]);

  return (
    <>
      <Loader show={switching} loadingText={t('loading')}>
        <DialogTitle>
          <Box display="flex" alignItems="center">
            <Typography variant="h5">{t('title')}</Typography>
            <Box flexGrow={1} />
            <IconButton
              onClick={() => setView(view === 'pin' ? 'pass' : 'pin')}
              size="small"
            >
              {view === 'pin' ? (
                <Menu fontSize="large" />
              ) : (
                <Apps fontSize="large" />
              )}
            </IconButton>
            <CloseButton action={close} />
          </Box>
        </DialogTitle>
        <Divider />

        <DialogContent>
          <Collapse in={view === 'pass'}>
            <Box margin={2} marginBottom={0}>
              <TextField
                fullWidth
                variant="outlined"
                label={t('fields.username')}
                value={username}
                onChange={e => setUsername(e.target.value)}
                inputRef={node => {
                  if (view !== 'pin') {
                    inputRef.current = node;
                  }
                }}
              />
            </Box>
          </Collapse>
          <Box margin={2}>
            <TextField
              fullWidth
              variant="outlined"
              label={view === 'pin' ? t('fields.pin') : t('fields.password')}
              type="password"
              value={view === 'pin' ? pin : password}
              onChange={e =>
                (view === 'pin' ? setPin : setPassword)(e.target.value)
              }
              inputRef={node => {
                if (view === 'pin') {
                  inputRef.current = node;
                }
              }}
            />
          </Box>
          <Box margin={2}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={switchUser}
              disabled={!enabled}
            >
              {view === 'pin'
                ? t('buttons.switchWithPin')
                : t('buttons.switchWithPass')}
            </Button>
          </Box>
        </DialogContent>
      </Loader>
    </>
  );
}
